import { render, staticRenderFns } from "./ratingInfo.vue?vue&type=template&id=21dd726f&scoped=true"
import script from "./ratingInfo.vue?vue&type=script&lang=js"
export * from "./ratingInfo.vue?vue&type=script&lang=js"
import style0 from "./ratingInfo.vue?vue&type=style&index=0&id=21dd726f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dd726f",
  null
  
)

export default component.exports